import React, { useEffect, useState } from "react";
import { FiCheckCircle, FiAlertCircle } from "react-icons/fi";
import { toastEmitter } from "../utils/toastEmitter"; // Adjust path if needed

const Toast: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [mode, setMode] = useState<"success" | "error">("success");

  useEffect(() => {
    const handleToast = ({ message, mode }: { message: string; mode: "success" | "error" }) => {
      setMessage(message);
      setMode(mode);
      setIsVisible(true);

      setTimeout(() => setIsVisible(false), 5000);
    };

    toastEmitter.on("toast", handleToast);

    return () => {
      toastEmitter.off("toast", handleToast);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 md:bottom-8 md:right-8 z-50">
      <div
        className={`flex items-center gap-2 sm:gap-3 p-3 sm:p-4 rounded-lg shadow-lg text-white max-w-[calc(100vw-2rem)] sm:max-w-xs md:max-w-sm ${
          mode === "success" ? "bg-green-500" : "bg-red-500"
        } animate-fade-in`}
      >
        {mode === "success" ?
          <FiCheckCircle className="min-w-5 w-5 h-5 sm:min-w-6 sm:w-6 sm:h-6" /> :
          <FiAlertCircle className="min-w-5 w-5 h-5 sm:min-w-6 sm:w-6 sm:h-6" />
        }
        <span className="text-xs sm:text-sm font-medium break-words">{message}</span>
      </div>
    </div>
  );
};

export default Toast;